import React, { ReactElement, useState } from "react";

import {
  BackgroundList,
  BackgroundListProps,
  BackgroundListRef,
} from "../components/lists/background/background-list";
import Filters from "../components/lists/filters";
import { FieldFilterDefinition } from "../generated/gql/graphql";
import useBackgroundFilters from "../hooks/use-background-filters";

export type BackgroundsPanelProps = Pick<
  BackgroundListProps,
  "selectedBackgroundId" | "selectedBackgroundIdChange" | "query" | "gridSize"
> & {
  backgroundListRef: React.RefObject<BackgroundListRef>;
};

export default function BackgroundsPanel({
  selectedBackgroundId,
  selectedBackgroundIdChange,
  query,
  gridSize,
  backgroundListRef,
}: BackgroundsPanelProps): ReactElement {
  const { fieldFilters: availableFilters } = useBackgroundFilters();

  const [activeFilters, setActiveFilters] = useState<FieldFilterDefinition[]>(
    [],
  );

  return (
    <>
      <Filters
        filters={availableFilters}
        onChangeFilters={setActiveFilters}
        selectedFilters={activeFilters}
      />
      <BackgroundList
        ref={backgroundListRef}
        query={query}
        filters={activeFilters}
        gridSize={gridSize}
        selectedBackgroundId={selectedBackgroundId}
        selectedBackgroundIdChange={selectedBackgroundIdChange}
      />
    </>
  );
}
